import { Component, HostListener, inject, DestroyRef } from '@angular/core';
import { NavItemComponent } from './nav-item/nav-item.component';
import { NavLogoComponent } from './nav-logo/nav-logo.component';
import { NgIcon } from '@ng-icons/core';
import { AuthService } from '../../../services/auth/auth.service';
import { CommonModule } from '@angular/common';
import { RolesAppService } from 'src/app/services/users/roles.app.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: true,
  imports: [NavItemComponent, NavLogoComponent, NgIcon, CommonModule],
})
export class SidebarComponent {
  readonly authService = inject(AuthService);
  readonly user$ = this.authService.user;
  mobileSidebarOpen = false;
  private destroyRef = inject(DestroyRef);

  constructor(
    public rolesAppService: RolesAppService,
    private router: Router,
  ) {
    // Close mobile sidebar on navigation
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        if (window.innerWidth < 768) {
          this.mobileSidebarOpen = false;
        }
      });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    // Auto-close mobile sidebar when resizing to desktop
    if ((event.target as Window).innerWidth >= 768) {
      this.mobileSidebarOpen = false;
    }
  }

  logout(): void {
    this.authService.logout().subscribe();
  }
}
